import React, { Component } from 'react';
import intl from "react-intl-universal";
import { Link, MemoryRouter as Router, Route } from "react-router-dom";
import PhaseI from "./newPMProjectPhaseI";
import PhaseII from "./newPMProjectPhaseII";
import PhaseIII from "./newPMProjectPhaseIII";
import PhaseIV from "./newPMProjectPhaseIV";
import PhaseEndpoint from "./newPMProjectPhaseEndpoint";
import UploadAborted from "./PMProjectUploadingAborted";
import ErrorMessages from './ErrorMessages';
import "../account.css";
import "./newPMProject.css";
import "react-table/react-table.css";
import { Step, StepLabel, Stepper } from '@material-ui/core';
import LoaderButton from "../LoaderButton";
import { Dialog, DialogContent } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { has } from 'core-js/core/dict';

var controller = new AbortController();
var signal = controller.signal;

class NewPMProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            userEmail: "",
            packageId: "",
            phaseNumber: 1,
            projectName: "",
            imagesSize: 0,
            acceptedPhotos: [],
            acceptedPhotosDictionary: {},
            fatalError: "",
            RequiredGP: 0,
            GPAmount: 0,
            MinimumNumOfPhotos: 15,
            MaximumNumOfPhotos: 20000,
            SelectedPodOutputs: "Mesh",       // Defaults of Step 2 page
            hasTrueOrtho: false,
            IsProjectAccessToEveryone: false, // Defaults of Step 2 page
            isGPSAccuracyRTK_PPK: false, // Defaults of Step 2 page
            isCaptureSceneWideArea: true, // Defaults of Step 2 page
            OutputFormatThreeD: "ThreeDMapping",
            OutputFormatGS: "GSplatting",
            OutputFormatTwoD: "TwoDMapping",
            SelectedVerticalDatum: "Ellipsoid",
            SelectedAltitudeMethod: "Absolute",
            progressState: 0,
            progressChunk: 0,
            isAborted: "",
            image1ClassName: "PMCloudImageButtons",
            image2ClassName: "PMCloudImageButtons",
            image3ClassName: "PMCloudImageButtons",
            image4ClassName: "PMCloudImageButtons",
            startProjectCounter: undefined,
            stepIndex: 1,
            runId: null,
            errorMessageString: "",
            showAbortDialog: false,
            endpoint_id: "",
            params: {},
            skipSteps: false,
            podName: "",
            queryParams: {},
            company: ""
        };
    }

    componentDidMount() {

        this.props.handleUpdates({
            customerLogoUrl: ""
        })
        
        var packageIdParam = window.location.search.toLowerCase().match(
            /[?&]packageid[=]([^&]+)/i
        );

        if (packageIdParam === null) {
            this.setState({ fatalError: intl.get("PM_New_Project_PackageId_Not_Found") });
            return;
        }
        
        this.getPMCloudData(packageIdParam !== null ? packageIdParam[1] : "");
        this.setState({packageId: packageIdParam[1]});

        const searchParams = new URLSearchParams(window.location.search);
        const queryParams = {};
        for (const [key, value] of searchParams.entries()) {
            // Exclude "packageid"
            if (key !== "packageId") {
                queryParams[key] = value;
            }
        }
        this.setState({ queryParams });
    }

    getEndpointParamsById = (endpoint_id) =>{
        let url = process.env.REACT_APP_LAMBDA_API_MANAGER + "/getEndpointById";

        fetch(url, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            isLocal: (process.env.REACT_APP_IS_LOCAL == 'true'),
            endpoint_id: endpoint_id ? endpoint_id : ''
          }),
        })
        .then((res) => { return res.json()})
        .then((result) => {
          if(result.ret.returnCode == "success"){
            result = JSON.parse(result.ret.data);
            this.setState(
                {
                    podName: result.length > 0 ?  result[0].endpoint_name : "",
                    params: result.length > 0 ? JSON.parse(result[0].params) : ""
                },()=>{
                    this.setState({isLoading: false});
                    if(result.length > 0 && result[0].global_params && result[0].global_params.filter(x=>x.name == "UPLOAD_FILES_UI")[0].defaultValue == "true"){
                        this.setState({skipSteps: false});
                    }else{
                        this.setState({skipSteps: true});
                    }
                }
            );
          }
        })
    }
    
    setPageNumer = (phaseNumber) => {
        this.setState({phaseNumber});
    }

    handleProjectName = (projectName) => {
        this.setState({ projectName });
    }
    
    handlePhaseIIImageClassName = (stateName, value) => {
        this.setState({ [stateName]: value });
    }

    handleSwitchSelectedPhotoMeshOutputs = (value) => {
        console.log("SelectedPodOutputs value: ", value);
        if (value === this.state.OutputFormatGS) {
            this.setState({ SelectedPodOutputs: "GS"}); // GSPlatting
        }
        else this.setState({ SelectedPodOutputs: "Mesh"}); // 3D Mesh model
    }

    handleSetOrthoPhotoOutputs = (value) => {
        this.setState({ hasTrueOrtho: value});
    }

    handleIsProjectAccessToEveryone = (value) => {
        this.setState({ IsProjectAccessToEveryone: value});
    }

    handleIsGPSAccuracy = (value) => {
        this.setState({ isGPSAccuracyRTK_PPK: value });
    }

    handleCapturedSceneIsWideArea = (value) => {
        this.setState({ isCaptureSceneWideArea: value });
    }
    
    handleAltitudeMethod = (value) => {
        if (value == "Relative") {
            this.setState({ SelectedVerticalDatum: "Ellipsoid" });
            this.setState({ SelectedAltitudeMethod: "Relative" });
        }
        else if (value === "Geoid") {
            this.setState({ SelectedVerticalDatum: "Geoid" });
            this.setState({ SelectedAltitudeMethod: "Absolute" });
        }
        else if (value === "Ellipsoid") {
            this.setState({ SelectedVerticalDatum: "Ellipsoid" });
            this.setState({ SelectedAltitudeMethod: "Absolute" });
        }
        
    }

    handleIsLoading = (value) => {
        this.setState({ isLoading: value});
    }

    getImgFromUrl = () =>{
        var queryParams = this.state.queryParams;
        var imgUrl = ""
        Object.keys(queryParams).forEach(key => {
            if(key == "customerImg"){
                imgUrl = queryParams[key];
            }
        })
        return imgUrl;
    }

    getPMCloudData(packageId) {
        fetch(process.env.REACT_APP_API_URL + "GetPMCloudData", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                packageId: packageId
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result !== undefined && result.Result !== undefined && result.Result.toString().toLowerCase() === "success") {    // If succeded
                    this.setState({ 
                        GPAmount: result.GPAmount,
                        userEmail: result.Email,
                        endpoint_id: result.endpoint_id,
                        company: result.Company
                    });
                    if(result.endpoint_id != ""){
                        this.getEndpointParamsById(result.endpoint_id);
                        this.props.handleUpdates({
                            customerLogoUrl: this.getImgFromUrl()
                        })
                    }else{
                        this.setState({ isLoading: false });
                        this.props.handleUpdates({
                            customerLogoUrl: ""
                        })
                    }
                }
                else {
                    if (result.ErrorMessage !== "")
                        this.setState({ fatalError: result.ErrorMessage, isLoading: false });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.props.handleServerError(true);
                console.error(error);
            });
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    CheckDuplicateFileNames = (filePath) => {
        if (this.state.acceptedPhotosDictionary[filePath.toLowerCase()] !== undefined) {
            return true;

        }
        return false;
    }

    AddAcceptedPhotos = (acceptedPhotos, acceptedPhotosDictionary, imagesSize, RequiredGP) => {
        var acceptedPhotosDictionaryTemp = Object.assign(this.state.acceptedPhotosDictionary, acceptedPhotosDictionary);

        this.setState(prevState => ({
            acceptedPhotos: this.state.acceptedPhotos.concat(acceptedPhotos),
            acceptedPhotosDictionary: acceptedPhotosDictionaryTemp,
            imagesSize: this.state.imagesSize + imagesSize,
            RequiredGP: this.state.RequiredGP + RequiredGP
        }));


        //console.log(this.state.acceptedPhotosDictionary);
    };

    RemoveAcceptedPhotos = () => {
        this.setState({ acceptedPhotos: [] });
        this.setState({ acceptedPhotosDictionary: {}});
        this.setState({imagesSize: 0});
        this.setState({RequiredGP: 0});
    }

    checkMovingFromPhaseItoPhaseII = () => {
        if (this.state.projectName !== "" && (this.state.acceptedPhotos === undefined || (this.state.acceptedPhotos !== undefined && this.state.acceptedPhotos.length > this.state.MaximumNumOfPhotos)))
            return intl.get("PM_New_Project_Maximum_Photos", {numOfPhotosRequired: this.state.MaximumNumOfPhotos});
        if (this.state.acceptedPhotos !== undefined && ((this.state.RequiredGP / this.state.GPAmount) * 100) > 100) {
            return intl.get("PM_Cloud_PhaseI_No_GP_Available");
        }
        if (this.state.projectName === "" && this.state.acceptedPhotos !== undefined && this.state.acceptedPhotos.length >= this.state.MinimumNumOfPhotos)
            return intl.get("PM_New_Project_Project_Name_Is_Missing");
        if (this.state.projectName !== "") {
            if (this.state.projectName.length > 32) {
                return intl.get("PM_Cloud_PhaseI_Error_Maximum_Characters");
            }
            let pattern = /^[\w\-]{1,32}$/;
            var match = pattern.exec(this.state.projectName);
            if (match == null) {
                return intl.get("PM_New_Project_Name_Illegal_Characters");
            }
        }
        if (this.state.projectName !== "" && (this.state.acceptedPhotos === undefined || (this.state.acceptedPhotos !== undefined && this.state.acceptedPhotos.length < this.state.MinimumNumOfPhotos)))
            return intl.get("PM_New_Project_Not_Enough_Photos", {numOfPhotosRequired: this.state.MinimumNumOfPhotos});
        if (this.state.projectName !== "" && this.state.acceptedPhotos !== undefined && this.state.acceptedPhotos.length >= this.state.MinimumNumOfPhotos && this.state.acceptedPhotos.length <= this.state.MaximumNumOfPhotos)
            return ""
        return intl.get("PM_Cloud_PhaseI_Error_Required_Params");
    }

    checkMovingFromPhaseIItoPhaseIII = () => {
        if (this.state.SelectedPodOutputs !== "" 
            && this.state.IsProjectAccessToEveryone !== undefined 
            && this.state.isGPSAccuracyRTK_PPK !== undefined 
            && this.state.isCaptureSceneWideArea !== undefined 
            && this.state.SelectedVerticalDatum 
            && this.state.SelectedAltitudeMethod){
                return true;
            }
        return false;
    }

    startUploading = () => {
        if(this.state.skipSteps){
            this.setState({isLoading: true});
        }
        this.setState({startProjectCounter: undefined});
        controller = new AbortController();
        signal = controller.signal;
        fetch(process.env.REACT_APP_API_URL + "InitPMProject", {
            method: "POST",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "packageId": this.state.packageId,
                "userIdentifier": this.state.projectName,
                "buildType": this.state.SelectedPodOutputs,
                "orthoPhoto": this.state.hasTrueOrtho,
                "publishPermissions": this.state.IsProjectAccessToEveryone ? 'all' : 'site',
                "gpsAccuracy": this.state.isGPSAccuracyRTK_PPK ? 'reliable' : 'standard',
                "capturedScene": this.state.isCaptureSceneWideArea ? 'wideAreaMapping' : 'closeRangeObject', 
                "verticalDatum": this.state.SelectedVerticalDatum,
                "altitudeMethod": this.state.SelectedAltitudeMethod,
                "gpRequested": this.state.RequiredGP,
                "filesCount": this.state.acceptedPhotos.length,
                "filesTotalSize": this.state.imagesSize,
                "skipSteps": this.state.skipSteps
            }),
        })
        .then((res) => res.json())
        .then((result) => {
            if (result.Result.toLowerCase() === 'success') {
                setTimeout(() => {
                    this.setState({runId: result.Data.runId});
                    if (this.state.isAborted === "Aborting") {
                        this.setState({isAborted: "Aborted", isLoading: false});
                        return;
                    }
    
                    this.getPresignedURLs(result.Data.runId, this.state.acceptedPhotos);
                }, 0);
            }
            else if (result.Result.toLowerCase() === "fail") {
                this.setState({errorMessageString: result.ErrorMessage, isLoading: false});
                this.setPageNumer(6);
                console.error(result.ErrorMessage);
            }
        })
        .catch(error=> {
            console.log(error);
            this.setState({
                errorMessageString: intl.get('PM_Cloud_ErrorMessagesPage_Generic_Error_Message'),
                isLoading: false
            });
            this.setPageNumer(6);
        })
    }

    getPresignedURLs = async (runId, files) => {

        var groupSize = 100;
        var fileGroups = [];

        this.setState({ startProjectCounter: files.length });
        for (let i = 0; i < files.length;) {
            fileGroups.push(files.slice(i, i + groupSize));
            i = i + groupSize;
        }

        if (this.state.progressChunk === 0) {
            //var progressChunk = (100 / (files.length + fileGroups.length) < 1) ? (100 / (files.length + fileGroups.length)).toFixed(2) : Math.ceil(100 / (files.length + fileGroups.length))
            this.setState({ progressChunk: 100 / (files.length + fileGroups.length) });
        }

        if(fileGroups.length == 0){
            this.startPMProject(runId);
            return;
        }

        for (let i = 0; i < fileGroups.length; i++) {

            let tempArray = fileGroups[i];
            let arrFilePaths = [];

            for (let j = 0; j < tempArray.length; j++) {
                arrFilePaths.push(tempArray[j].path.replace(/^[\/\\]+/, ''));
            }

            let inputData = {
                runId: runId,
                fileNames: arrFilePaths
            };

            this.setState({ progressState: parseFloat(this.state.progressState) + parseFloat(this.state.progressChunk) });

            await fetch(process.env.REACT_APP_API_URL + "GetPreSignedURLs", {
                method: 'POST',
                credentials: "include",
                signal: signal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(inputData)
            })
                .then(res => res.json())
                .then(async (result) => {
                    if (result.Result.toLowerCase() == 'success') {
                        await this.uploadFiles(files, result.Data.fileToURL, runId);
                    }
                    else if(result.Result.toLowerCase() == 'fail') {
                        this.setState({errorMessageString: result.ErrorMessage});
                        this.setPageNumer(6);
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.setState({errorMessageString: intl.get('PM_Cloud_ErrorMessagesPage_Generic_Error_Message')});
                    this.setPageNumer(6);
                });

            if (this.state.isAborted === "Aborting") {
                this.setState({ isAborted: "Aborted" });
                break;
            }
        }
    }

    uploadFiles = async (files, fileToURL, runId) => {

        var arrRequests = [];
        for (let i = 0; i < files.length; i++) {
            var filePath = files[i].path.replace(/^[\/\\]+/, '');
            if (fileToURL[filePath]) {

                const url = fileToURL[filePath];

                arrRequests.push(fetch(url, {
                    method: 'PUT',
                    body: files[i],
                    signal: signal,
                })
                    .then(res => res.text())
                    .then(data => {
                        this.setState({ startProjectCounter: this.state.startProjectCounter - 1 });
                        var newProgressState = parseFloat(this.state.progressState) + parseFloat(this.state.progressChunk);
                        if (newProgressState >= 99)
                            this.setState({ progressState: 99 });
                        else this.setState({ progressState: newProgressState });

                        if (this.state.startProjectCounter === 0) {      // it means that all the files are uploaded successfully
                            this.startPMProject(runId);
                        }
                    })
                    .catch((error) => {
                        if (error.code === 20 || error.name === "AbortError")
                            console.log(error);
                        else console.error(error);
                    }));

                if (this.state.isAborted == "Aborting") {
                    this.setState({ isAborted: "Aborted" });
                    break;
                }
            }
        }

        return Promise.all(arrRequests);
    }

    startPMProject = (runId) => {
        fetch(process.env.REACT_APP_API_URL + "StartPMProject", {
            method: 'POST',
            credentials: "include",
            signal: signal,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                runId,
                params: this.state.params,
                skipSteps: this.state.skipSteps,
                podName: this.state.podName,
                identifier: this.state.projectName,
                endpoint_id: this.state.endpoint_id
            }),
        })
            .then(res => res.json())
            .then((result) => {
                this.setState({isLoading: false});
                if (result.Result.toLowerCase() == 'success') {
                    this.setState({ progressState: 100 });
                    this.setState({ phaseNumber: 4 });
                }
                else {
                    if (result.Result.toLowerCase() == 'fail' && result.ErrorMessage !== undefined) {
                        this.setState({errorMessageString: result.ErrorMessage});
                        this.setPageNumer(6);
                    }
                    else {
                        this.setState({errorMessageString: intl.get('PM_Cloud_ErrorMessagesPage_Generic_Error_Message')});
                        this.setPageNumer(6);
                    }
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({
                    errorMessageString: intl.get('PM_Cloud_ErrorMessagesPage_Generic_Error_Message'),
                    isLoading: false
                });
                this.setPageNumer(6);
            })
    }
    
    handleShowAbortDialog = (value) => {
        this.setState({ showAbortDialog: value});
    }

    handleAbortUploading = () => {
        controller.abort();
        fetch(process.env.REACT_APP_API_URL + "AbortPMProject", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                runId: this.state.runId,
            }),
        })
            .then(res => res.json())
            .then((result) => {
                if (result.Result) {
                    if (result.Result.toLowerCase() == 'success') {
                        this.setPageNumer(5);
                    }
                    else if (result.Result.toLowerCase() == 'fail') {
                        console.log(result.ErrorMessage);
                        this.setPageNumer(5);
                    }
                }
            })
            .catch(error => {
                console.error(error);
                this.setPageNumer(5);
            })
        
    }

    handleUpdates = (params) => {     
        this.setState(params);
    }

    render() {
        return (
            <div>
                <Router>
                    {this.state.fatalError ?
                        <div id="fatalError">
                            <h3>
                                {this.state.fatalError}
                            </h3>
                        </div>
                        :
                        this.state.isLoading ? 
                            <Dialog
                                open={this.state.isLoading}
                                aria-labelledby="form-dialog-title align-center"
                            >
                                <DialogContent>
                                <CircularProgress size={60}/>
                                </DialogContent>
                            </Dialog>
                        :
                        <React.Fragment>
                            <div className="container accountContainer cloudProcessingContainer">
                                {
                                ((this.state.phaseNumber === 1 && this.state.endpoint_id && this.state.skipSteps) 
                                || (this.state.phaseNumber === 2 && this.state.endpoint_id)) ? 
                                    <PhaseEndpoint
                                        params={this.state.params}
                                        endpoint_id={this.state.endpoint_id}
                                        startUploading={this.startUploading}
                                        runId={this.state.runId}
                                        startPMProject={this.startPMProject}
                                        handleUpdates={this.handleUpdates}
                                        projectName={this.state.projectName}
                                        skipSteps={this.state.skipSteps}
                                        handleProjectName={this.handleProjectName}
                                        checkMovingFromPhaseIItoPhaseIII={this.checkMovingFromPhaseIItoPhaseIII}
                                        setPageNumer={this.setPageNumer}
                                        isSubLoginType={this.props.isSubLoginType}
                                        company={this.state.company}
                                    />
                                :
                                this.state.phaseNumber === 1 ?
                                    <PhaseI 
                                        setPageNumer={this.setPageNumer} 
                                        projectName={this.state.projectName} 
                                        handleProjectName={this.handleProjectName} 
                                        acceptedPhotos={this.state.acceptedPhotos} 
                                        AddAcceptedPhotos={this.AddAcceptedPhotos} 
                                        CheckDuplicateFileNames={this.CheckDuplicateFileNames} 
                                        RemoveAcceptedPhotos={this.RemoveAcceptedPhotos} 
                                        handleErrorMessage={this.handleErrorMessage} 
                                        GPAmount={this.state.GPAmount} 
                                        formatBytes={this.formatBytes} 
                                        RequiredGP={this.state.RequiredGP} 
                                        imagesSize={this.state.imagesSize} 
                                        checkMovingFromPhaseItoPhaseII={this.checkMovingFromPhaseItoPhaseII} 
                                        MinimumNumOfPhotos={this.state.MinimumNumOfPhotos} 
                                        isLoading={this.state.isLoading} 
                                        handleIsLoading={this.handleIsLoading}
                                        endpoint_id={this.state.endpoint_id}
                                        isSubLoginType={this.props.isSubLoginType}
                                        company={this.state.company}
                                    />
                                :  (this.state.phaseNumber === 2) ?
                                    <PhaseII 
                                        setPageNumer={this.setPageNumer} 
                                        projectName={this.state.projectName} 
                                        acceptedPhotos={this.state.acceptedPhotos} 
                                        handleSwitchSelectedPhotoMeshOutputs={this.handleSwitchSelectedPhotoMeshOutputs} 
                                        handleSetOrthoPhotoOutputs={this.handleSetOrthoPhotoOutputs} 
                                        SelectedPodOutputs={this.state.SelectedPodOutputs} 
                                        handleIsProjectAccessToEveryone={this.handleIsProjectAccessToEveryone} 
                                        IsProjectAccessToEveryone={this.state.IsProjectAccessToEveryone} 
                                        handleIsGPSAccuracy={this.handleIsGPSAccuracy} 
                                        handleCapturedSceneIsWideArea={this.handleCapturedSceneIsWideArea} 
                                        OutputFormatThreeD={this.state.OutputFormatThreeD} 
                                        OutputFormatGS={this.state.OutputFormatGS}
                                        OutputFormatTwoD={this.state.OutputFormatTwoD} 
                                        SelectedVerticalDatum={this.state.SelectedVerticalDatum} 
                                        handleAltitudeMethod={this.handleAltitudeMethod} 
                                        handlePhaseIIImageClassName={this.handlePhaseIIImageClassName} 
                                        image1ClassName={this.state.image1ClassName} 
                                        image2ClassName={this.state.image2ClassName} 
                                        image3ClassName={this.state.image3ClassName} 
                                        image4ClassName={this.state.image4ClassName} 
                                        checkMovingFromPhaseIItoPhaseIII={this.checkMovingFromPhaseIItoPhaseIII}
                                    />
                                : this.state.phaseNumber === 3 ?
                                    <PhaseIII 
                                        setPageNumer={this.setPageNumer} 
                                        projectName={this.state.projectName} 
                                        acceptedPhotos={this.state.acceptedPhotos} 
                                        startUploading={this.startUploading} 
                                        progressState={this.state.progressState} 
                                        handleShowAbortDialog={this.handleShowAbortDialog} 
                                        showAbortDialog={this.state.showAbortDialog} 
                                        handleAbortUploading={this.handleAbortUploading}
                                        isSubLoginType={this.props.isSubLoginType}
                                    />
                                : this.state.phaseNumber === 4 ?
                                    <PhaseIV 
                                        setPageNumer={this.setPageNumer}
                                        skipSteps={this.state.skipSteps}
                                        isSubLoginType={this.props.isSubLoginType}
                                    />
                                : this.state.phaseNumber === 5 ?
                                    <UploadAborted />
                                : this.state.phaseNumber === 6 ?
                                    <ErrorMessages 
                                        errorMessageString={this.state.errorMessageString} 
                                        userEmail={this.state.userEmail} 
                                        packageId={this.state.packageId}
                                        isSubLoginType={this.props.isSubLoginType}
                                    />
                                : null}
                            </div>
                        </React.Fragment>
                    }
                </Router>
            </div>
        );
    }
}

export default NewPMProject;